import React, { useEffect, useState, useContext } from "react";
import { AdminContext } from "../../contexts/AdminContext";
import Section from "../custom/Section";
import NavLink from "./NavLink";
import { Box, Center, VStack } from "@chakra-ui/react";
import Logo from "../brand/Logo";
import { Link } from "react-router-dom";
import Logout from "./Logout";
import NewAdmin from './NewAdmin'

type Props = { display: any }

const SideNav: React.FC<Props> = ({ display }) => {
  const [activePage, setActivePage] = useState({
    dashboard: false,
    users: false,
    orders: false,
    products: false,
    profile: false,
    newAdmin: false
  })

  const { admin } = useContext(AdminContext)

  useEffect(() => {
    const page = window.location.href.split("/").pop()
    const url = window.location.href.split("/")

    if (page === "dashboard") {
      setActivePage({
        ...activePage,
        dashboard: true,
      })
    }

    if (page === "users") {
      setActivePage({
        ...activePage,
        users: true,
      })
    }

    if (page === "orders" || url.includes('orders')) {
      setActivePage({
        ...activePage,
        orders: true,
      })
    }

    if (page === "products") {
      setActivePage({
        ...activePage,
        products: true,
      })
    }

    if (page === "profile") {
      setActivePage({
        ...activePage,
        profile: true,
      })
    }

    if (page === "new_admin") {
      setActivePage({
        ...activePage,
        newAdmin: true,
      })
    }
  }, [])

  const linkData = [
    {
      text: 'Dashboard',
      linkTarget: '/dashboard',
      activePage: activePage.dashboard,
      icon: 'material-symbols:dashboard'
    },

    {
      text: 'Users',
      linkTarget: '/users',
      activePage: activePage.users,
      icon: 'mdi:users-group'
    },

    {
      text: 'Orders',
      linkTarget: '/orders',
      activePage: activePage.orders,
      icon: 'material-symbols:order-approve'
    },

    {
      text: 'Products',
      linkTarget: '/products',
      activePage: activePage.products,
      icon: 'dashicons:products'
    },

    {
      text: 'Profile',
      linkTarget: '/profile',
      activePage: activePage.profile,
      icon: 'iconamoon:profile-fill'
    }
  ]

  return (
    <Section>
      <Box
        w='100%' display={display}
        maxW={{ md: '14rem', lg: '15rem' }} h='100vh' pos="fixed" overflowY='auto'
        bg='#313338'
      >
        <Center w="100%" h="70px">
          <Link to='/dashboard'>
            <Logo
              color='#B5BAC1' fontSize="2xl"
              imgSize="45px"
            />
          </Link>
        </Center>

        <VStack mt='20px'>
          <VStack spacing='15px'>
            {linkData.map((linkDatum, i) => (
              <NavLink
                key={i}
                icon={linkDatum.icon}
                text={linkDatum.text}
                linkTarget={linkDatum.linkTarget}
                activePage={linkDatum.activePage}
              />
            ))}

            {admin.role === 'super' && 
              <NewAdmin activePage={activePage.newAdmin}/>
            }
          </VStack>

          <Center w="100%">
            <Box pos='fixed' bottom={20}>
              <Logout />
            </Box>
          </Center>
        </VStack>
      </Box>
    </Section>
  )
}

export default SideNav